import axios from "axios";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

const actions = {
    async loadAnalyses({ dispatch, rootState }, params) {
        const token = rootState.authToken;

        await dispatch("medicalAnalysesForm/fetchAnalysesTypes", null, { root: true });

        const { page, filters } = params;
        const url = addAuthKey(`${api_url}/?r=api/reports/workers-medical-analyses/index&page=${page}&${filters}`, token);
        
        const { data } = await axios.get(url);

        return data;
    },

};

export default {
    namespaced: true,
    actions
};
